import React from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

const Header = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (isMobile) {
    return <MobileHeader />;
  }

  return <DesktopHeader />;
};

export default Header;
